import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    h: "Information We Collect",
    p: "We collect only the information you voluntarily provide through our contact form and newsletter signups — namely your name and email address. We do not sell or share your personal data with third parties.",
  },
  {
    h: "How We Use It",
    p: "Contact submissions are used solely to respond to your inquiry. Newsletter emails are used only to notify you of upcoming releases from Sorrow & Serenity Music artists. You may opt out at any time.",
  },
  {
    h: "KSSR Radio Streaming",
    p: "KSSR broadcasts direct-licensed, unsigned music. No account or personal data is required to listen. Standard technical data (such as your IP) may be processed by our streaming provider to deliver audio.",
  },
  {
    h: "Contact",
    p: "For any privacy-related questions, reach us through the Submissions & Contact page.",
  },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="pt-32 md:pt-40 bg-charcoal min-h-screen">
      <div className="max-w-3xl mx-auto px-4 md:px-12 pb-24 md:pb-32">
        <Reveal>
          <p className="font-label uppercase tracking-[0.35em] text-crimson-bright text-xs mb-4">Legal</p>
          <h1 className="font-display font-black text-5xl md:text-6xl text-softwhite tracking-tight">PRIVACY</h1>
        </Reveal>
        <div className="mt-14 space-y-10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.08}>
              <h2 className="font-label uppercase tracking-[0.15em] text-lg text-softwhite">{s.h}</h2>
              <p className="mt-3 text-slate leading-relaxed font-body">{s.p}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
